import React from "react";
import { capitalizeWords } from "../../utils/util";

function getMonthName(monthNumber) {
  const monthNames = [
  "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


  // Validate the month number
  if (monthNumber >= 1 && monthNumber <= 12) {
    return monthNames[monthNumber - 1];
  } else {
    return "Invalid month number";
  }
}

function formatDate(date) {
  return date.split("T")[0].split("-");
}

const SickLeaveCard = ({
  data,
  toDate,
  fromDate,
  orderPlaceDate,
  doctorName,
  onViewCertificate,
  onPayment,
  paymentStatus,
  translationMap,
  isMobile
}) => {
  let formatToDate = formatDate(toDate);
  let formatFromDate = formatDate(fromDate);
  let formatOrderPlaceDate = formatDate(orderPlaceDate);
  paymentStatus = paymentStatus.toLowerCase();
  return (
    <div className="Sick_Leave_Main_Wrapper">
            <div className="Sick_leave_white_box">
                <div className="sick_inner_box1">
                    <div className="date_box">
                        <h6 className="Gray_Title">
                            {getMonthName(formatOrderPlaceDate[1]).toUpperCase().slice(0, 3)}
                            <b>{formatOrderPlaceDate[2]}</b>
                            {formatOrderPlaceDate[0]}
                        </h6>
                    </div>
                    <div className="content_box">
                        {paymentStatus === "success" ?
            <p className="active">
                                <span className="circle_icon active_icon"></span>
                                {translationMap?.attested}
                            </p> :

            paymentStatus.toLowerCase() === "initiated" ? <>
                                <p className="active">
                                        <span className="circle_icon yellow_icon">
                                        </span>
                                    {translationMap?.waitingPaymentConfirmation}
                                </p>
                            </> : <>
                                <p className="active">
                                    <span className="circle_icon nonactive_icon"></span>
                                    {translationMap?.not_attested}
                                </p>
                            </>

            }

                        <h6 className="name_txt">{capitalizeWords(doctorName)}</h6>
                        <ul className="detail_ul_box">
                            <li>
                                <p>
                                    <span>{translationMap?.valid_from}: &nbsp;</span>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">{`${getMonthName(
                      formatFromDate[1]
                    )} ${formatFromDate[2]} ${formatFromDate[0]}`}</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>{translationMap?.to}: &nbsp;</span>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">{`${getMonthName(
                      formatToDate[1]
                    )} ${formatToDate[2]} ${formatToDate[0]}`}</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="sick_inner_box2">
                    <div className="btn_innerwrap">
                        {paymentStatus !== "success" ?
            <button
              className={paymentStatus === "initiated" ? "disabled_btn_link" : "blue_btn_link"}
              onClick={() => {
                onPayment();
              }}
              disabled={paymentStatus === "initiated"}>
              
                                {translationMap?.attest_certificate}
                            </button> :

            ""
            }

                        {!isMobile &&
            <div className=" button2">
                                <button onClick={(e) => onViewCertificate(data, "download", e)}>
                                    <div className="content">
                                        <span className="button-text">{translationMap?.download_certificate}</span>
                                        <i className="fa-solid fa-download"></i>
                                    </div>
                                </button>
                            </div>
            }

                        <button className="view_btn_link" onClick={() => onViewCertificate(data, "view")}>
                            {translationMap?.view_certificate}
                        </button>
                    </div>
                </div>
            </div>
        </div>);

};

export default SickLeaveCard;